const searchParams = new URLSearchParams(location.search);
const engagementId = (searchParams.get('engagementId') || searchParams.get('engagementid')) ?? undefined;

export function clickActionArgs(name, controlType, locationInPage, URL) {
	let baseArgs = {
		web: {
			webInteraction: {
				name,
				type: 'other'
			},
			_etassureco: {
				controlType
			}
		},
		siteKnowledge: {
			supportSiteSearch: {
				locationInPage
			}
		}
	};

	if (URL) {
		baseArgs.web.webInteraction.URL = URL;
	}

	return baseArgs;
}
export function pageViewArgs(name, siteSection, isHomePage = false, isErrorPage = false) {
	let baseArgs = {
		web: {
			webPageDetails: {
				name,
				siteSection,
				isHomePage,
				isErrorPage
			}
		}
	};

	if (engagementId) {
		if (!baseArgs.web._etassureco) {
			baseArgs.web._etassureco = {engagementNumber: engagementId};
		}
	}

	return baseArgs;
}
